import { useEffect } from 'react';
import { pdfjs } from 'react-pdf';

export const usePdfWorker = () => {
  useEffect(() => {
    // Use CDN URL for the PDF worker
    pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;
  }, []);
};
